import { Button, Stack } from "@mui/material";
import ReservationQuestionAnswers from "../../../form/reservation/ReservationQuestionAnswers";
import WushCard from "../../../layout/WushCard";

export default function AdditionalInformation({ nextStep, reservations }) {
  return (
    <Stack>
      <WushCard bgcolor={"#ffffff"}>
        <Stack p={2}>
          <Stack mb={1}>
            <ReservationQuestionAnswers reservation={reservations[0]} />
          </Stack>
          <Stack direction="row" width="100%" justifyContent="right">
            <Button width="500px" size="large" variant="contained" onClick={nextStep}>Continue</Button>
          </Stack>
        </Stack>
      </WushCard>
    </Stack>
  );
}